import type { Shift } from '../types';

/**
 * When saving the roster, the client may have a stale shift list. Shifts that exist on the server
 * but not locally were either (a) added by another device/session, or (b) removed locally since load.
 * We treat (b) as: shift id was in `baselineIds` when the user started from server — do not restore.
 * Anything on the server that is not local and not in baseline is merged in (external adds).
 */
export function mergeExternalRosterShifts(
  localShifts: Shift[],
  serverShifts: Shift[] | null | undefined,
  baselineIds: ReadonlySet<string>
): { merged: Shift[]; externalAdded: Shift[] } {
  if (!serverShifts?.length) {
    return { merged: localShifts, externalAdded: [] };
  }
  const localIds = new Set(localShifts.map((s) => s.id));
  const externalAdded: Shift[] = [];
  for (const s of serverShifts) {
    if (localIds.has(s.id)) continue;
    if (baselineIds.has(s.id)) continue;
    externalAdded.push(s);
  }
  if (externalAdded.length === 0) {
    return { merged: localShifts, externalAdded: [] };
  }
  return { merged: [...localShifts, ...externalAdded], externalAdded };
}
